import clsx from 'clsx'
import React, { createElement } from 'react'

const headingClasses = {
  1: 'text-4xl font-bold',
  2: 'text-2xl font-semibold',
  3: 'text-xl font-semibold',
  4: 'text-base font-semibold',
  5: 'text-sm font-medium',
  6: 'text-xs font-semibold'
} as const

type Level = keyof typeof headingClasses

type HeadingProps = {
  level: Level
  children: React.ReactNode
  className?: string
  title?: string
}

export const Heading = ({
  level,
  children,
  className,
  title
}: HeadingProps) => {
  const hasTextColor = className ? className.includes('text-') : false
  const combinedClassName = clsx(
    headingClasses[level],
    'text-balance',
    !hasTextColor && 'text-darkBlack',
    className
  )

  return createElement(
    `h${level}`,
    {
      className: combinedClassName,
      title
    },
    children
  )
}
